{
  "level": "do02",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:do02",
    "objects": "AREAS.E3:do02.e3",
    "mesh": "TREES.E3:do02.e3"
  },
  "spawn_point": {
    "position": [
      1798.2490939876425,
      1442.1213973012714,
      133.97534942626953
    ],
    "facing_rad": 0.0,
    "look_point": [
      1798.2490939876425,
      1542.1213973012714,
      133.97534942626953
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      1430.0,
      1353.199951171875,
      109.97534942626953
    ],
    "bbox_max": [
      2015.62939453125,
      1480.0,
      370.0
    ],
    "vertex_count": 263,
    "vertices": [
      [
        1430.0,
        1400.0,
        290.0
      ],
      [
        1430.0,
        1400.0,
        140.0
      ],
      [
        1430.0,
        1400.0,
        140.0
      ],
      [
        1430.0,
        1400.0,
        115.65217590332031
      ],
      [
        1499.553466796875,
        1400.0,
        138.0
      ],
      [
        1499.7784423828125,
        1400.0,
        138.0
      ],
      [
        1499.553466796875,
        1400.0,
        138.0
      ],
      [
        1460.0,
        1400.0,
        138.0
      ],
      [
        1499.7784423828125,
        1400.0,
        138.0
      ],
      [
        1499.7784423828125,
        1400.0,
        140.0
      ],
      [
        1480.0,
        1419.553466796875,
        138.0
      ],
      [
        1480.0,
        1419.553466796875,
        138.0
      ],
      [
        1480.0,
        1400.0,
        138.0
      ],
      [
        1630.0,
        1469.9998779296875,
        370.0
      ],
      [
        1630.0,
        1469.9998779296875,
        140.0
      ],
      [
        1480.0,
        1469.9998779296875,
        138.0
      ],
      [
        1480.0,
        1469.9998779296875,
        120.0
      ],
      [
        1550.0,
        1480.0,
        120.0
      ],
      [
        1550.0,
        1469.9998779296875,
        120.0
      ],
      [
        1560.0001220703125,
        1469.9998779296875,
        120.0
      ],
      [
        1630.0,
        1450.0,
        120.0
      ],
      [
        1630.0,
        1450.0,
        138.0
      ],
      [
        1630.0,
        1450.0,
        140.0
      ],
      [
        1530.0,
        1450.0,
        138.0
      ],
      [
        1500.0,
        1450.0,
        138.0
      ],
      [
        1480.0,
        1450.0,
        138.0
      ],
      [
        1630.0,
        1450.0,
        138.0
      ],
      [
        1630.0,
        1470.0,
        138.0
      ],
      [
        1587.455810546875,
        1467.9998779296875,
        138.0
      ],
      [
        1630.0,
        1470.0,
        140.0
      ],
      [
        1630.0,
        1468.0,
        138.0
      ],
      [
        1500.0,
        1467.999755859375,
        138.0
      ],
      [
        1500.0,
        1450.0,
        138.0
      ],
      [
        1500.0,
        1450.0,
        140.0
      ],
      [
        1630.0,
        1450.0001220703125,
        120.0
      ],
      [
        1500.0,
        1440.0,
        138.0
      ],
      [
        1480.0,
        1440.0,
        138.0
      ],
      [
        1500.0,
        1440.0,
        138.0
      ],
      [
        1500.0,
        1440.0,
        140.0
      ],
      [
        2015.62939453125,
        1469.9998779296875,
        135.99945068359375
      ],
      [
        2008.634765625,
        1469.9998779296875,
        120.00121307373047
      ],
      [
        2008.634765625,
        1469.9998779296875,
        151.99774169921875
      ],
      [
        2015.62939453125,
        1469.9998779296875,
        135.99945068359375
      ],
      [
        2008.634765625,
        1469.9998779296875,
        120.00121307373047
      ],
      [
        1996.7265625,
        1469.9998779296875,
        109.97534942626953
      ],
      [
        1770.0,
        1469.9998779296875,
        220.0
      ],
      [
        1770.0,
        1469.9998779296875,
        120.0
      ],
      [
        1789.3779296875,
        1469.9998779296875,
        135.0
      ],
      [
        1814.019287109375,
        1469.9998779296875,
        135.0
      ],
      [
        1865.980712890625,
        1469.9998779296875,
        135.0
      ],
      [
        1890.6220703125,
        1469.9998779296875,
        135.0
      ],
      [
        1840.0,
        1469.9998779296875,
        135.0
      ],
      [
        1865.980712890625,
        1469.9998779296875,
        135.0
      ],
      [
        1814.019287109375,
        1469.9998779296875,
        135.0
      ],
      [
        1840.0,
        1469.9998779296875,
        135.0
      ],
      [
        1840.0,
        1469.9998779296875,
        120.0
      ],
      [
        1814.0194091796875,
        1469.9998779296875,
        120.0
      ],
      [
        1865.9805908203125,
        1469.9998779296875,
        120.0
      ],
      [
        1840.0,
        1469.9998779296875,
        120.0
      ],
      [
        1890.6220703125,
        1469.9998779296875,
        120.0
      ],
      [
        1865.9805908203125,
        1469.9998779296875,
        120.0
      ],
      [
        1789.3779296875,
        1469.9998779296875,
        120.0
      ],
      [
        1814.0194091796875,
        1469.9998779296875,
        120.0
      ],
      [
        1789.3779296875,
        1469.9998779296875,
        120.0
      ],
      [
        1789.3779296875,
        1469.9998779296875,
        135.0
      ],
      [
        1890.6220703125,
        1469.9998779296875,
        120.0
      ],
      [
        1890.6220703125,
        1469.9998779296875,
        135.0
      ],
      [
        1695.0,
        1469.9998779296875,
        120.0
      ],
      [
        1655.0001220703125,
        1469.9998779296875,
        120.0
      ],
      [
        1655.0001220703125,
        1469.9998779296875,
        120.0
      ],
      [
        1655.0,
        1469.9998779296875,
        135.0
      ],
      [
        1883.3011474609375,
        1400.0,
        120.0
      ],
      [
        1796.69873046875,
        1400.0,
        120.0
      ],
      [
        1875.2664794921875,
        1400.0,
        120.0
      ],
      [
        1883.3011474609375,
        1400.0,
        120.0
      ],
      [
        1796.69873046875,
        1400.0,
        120.0
      ],
      [
        1804.7335205078125,
        1400.0,
        120.0
      ],
      [
        1951.0,
        1400.0140380859375,
        120.001220703125
      ],
      [
        1974.56298828125,
        1400.0140380859375,
        120.001220703125
      ],
      [
        2008.634765625,
        1400.0140380859375,
        120.001220703125
      ],
      [
        2003.7996826171875,
        1353.199951171875,
        115.93043518066406
      ],
      [
        1655.0001220703125,
        1454.761962890625,
        124.76190948486328
      ],
      [
        1630.0,
        1454.761962890625,
        124.76190948486328
      ],
      [
        1770.0,
        1454.761962890625,
        124.76190185546875
      ],
      [
        1695.0,
        1454.761962890625,
        124.76190948486328
      ],
      [
        1862.05908203125,
        1463.20751953125,
        125.49629974365234
      ],
      [
        1840.0,
        1469.1181640625,
        126.01026916503906
      ],
      [
        1840.0,
        1469.1181640625,
        126.01026916503906
      ],
      [
        1817.94091796875,
        1463.20751953125,
        125.49629974365234
      ],
      [
        1804.7335205078125,
        1450.0,
        120.0
      ],
      [
        1817.94091796875,
        1463.20751953125,
        125.49629974365234
      ],
      [
        1809.495361328125,
        1454.7618408203125,
        124.76189422607422
      ],
      [
        1875.2664794921875,
        1450.0,
        120.0
      ],
      [
        1870.504638671875,
        1454.7618408203125,
        124.76189422607422
      ],
      [
        1862.05908203125,
        1463.20751953125,
        125.49629974365234
      ],
      [
        1902.6785888671875,
        1452.32373046875,
        122.32376861572266
      ],
      [
        1902.6785888671875,
        1452.32373046875,
        120.0
      ],
      [
        1777.3212890625,
        1452.3236083984375,
        120.0
      ],
      [
        1777.3212890625,
        1452.3236083984375,
        122.32359313964844
      ],
      [
        1770.0,
        1450.36181640625,
        120.0
      ],
      [
        1770.0,
        1450.36181640625,
        120.36188507080078
      ],
      [
        1655.0001220703125,
        1454.761962890625,
        124.76190948486328
      ],
      [
        1655.0001220703125,
        1469.9998779296875,
        126.08694458007812
      ],
      [
        1770.0,
        1469.9998779296875,
        126.08694458007812
      ],
      [
        1770.0,
        1454.7618408203125,
        124.76190185546875
      ],
      [
        1779.378173828125,
        1460.0,
        125.21739196777344
      ],
      [
        1789.3779296875,
        1469.9998779296875,
        126.08694458007812
      ],
      [
        1779.378173828125,
        1460.0,
        125.21739196777344
      ],
      [
        1777.974609375,
        1454.7618408203125,
        124.76190185546875
      ],
      [
        2010.134521484375,
        1453.431396484375,
        123.43146514892578
      ],
      [
        2008.634765625,
        1450.001220703125,
        120.001220703125
      ],
      [
        2010.134521484375,
        1453.431396484375,
        123.43146514892578
      ],
      [
        2011.2955322265625,
        1469.9998779296875,
        126.08694458007812
      ],
      [
        2010.7161865234375,
        1454.7618408203125,
        124.76190185546875
      ],
      [
        1900.6217041015625,
        1460.0,
        125.21739196777344
      ],
      [
        1890.6220703125,
        1469.9998779296875,
        126.08694458007812
      ],
      [
        1951.0,
        1453.431396484375,
        123.43146514892578
      ],
      [
        1951.0,
        1450.001220703125,
        120.001220703125
      ],
      [
        1900.6217041015625,
        1460.0,
        125.21739196777344
      ],
      [
        1902.0252685546875,
        1454.7618408203125,
        124.76190185546875
      ],
      [
        2010.6656494140625,
        1453.431396484375,
        124.64620971679688
      ],
      [
        2008.634765625,
        1400.0140380859375,
        120.001220703125
      ],
      [
        2010.6656494140625,
        1453.431396484375,
        124.64620971679688
      ],
      [
        1951.0,
        1427.968505859375,
        122.43204498291016
      ],
      [
        1910.0,
        1427.968505859375,
        122.43204498291016
      ],
      [
        1951.0,
        1453.431396484375,
        124.64620971679688
      ],
      [
        1951.0,
        1427.968505859375,
        122.43204498291016
      ],
      [
        1910.0,
        1450.0,
        124.34782409667969
      ],
      [
        1910.0,
        1427.968505859375,
        122.43204498291016
      ],
      [
        1796.67724609375,
        1427.968505859375,
        120.0
      ],
      [
        1801.7926025390625,
        1447.05908203125,
        124.09208679199219
      ],
      [
        1796.67724609375,
        1427.968505859375,
        122.43204498291016
      ],
      [
        1883.32275390625,
        1427.968505859375,
        120.0
      ],
      [
        1883.32275390625,
        1427.968505859375,
        122.43204498291016
      ],
      [
        1878.2073974609375,
        1447.05908203125,
        124.09208679199219
      ],
      [
        1801.7926025390625,
        1447.05908203125,
        124.09208679199219
      ],
      [
        1878.2073974609375,
        1447.05908203125,
        124.09208679199219
      ],
      [
        1910.0,
        1450.0,
        124.34782409667969
      ],
      [
        1903.30126953125,
        1450.0,
        124.34782409667969
      ],
      [
        1903.30126953125,
        1450.0,
        124.34782409667969
      ],
      [
        1700.0001220703125,
        1454.761962890625,
        124.76190948486328
      ],
      [
        1700.0001220703125,
        1447.916748046875,
        124.16667175292969
      ],
      [
        1655.0001220703125,
        1454.761962890625,
        124.76190948486328
      ],
      [
        1655.0001220703125,
        1447.916748046875,
        124.16667175292969
      ],
      [
        1655.0001220703125,
        1447.916748046875,
        124.16667175292969
      ],
      [
        1650.0,
        1447.9166259765625,
        124.16666412353516
      ],
      [
        1700.0001220703125,
        1447.916748046875,
        124.16667175292969
      ],
      [
        1695.0,
        1447.9166259765625,
        124.16666412353516
      ],
      [
        1776.69873046875,
        1450.0,
        124.34782409667969
      ],
      [
        1770.0,
        1450.0,
        124.34782409667969
      ],
      [
        1776.69873046875,
        1450.0,
        124.34782409667969
      ],
      [
        1770.0,
        1450.0,
        124.34782409667969
      ],
      [
        1951.0,
        1417.968505859375,
        121.5624771118164
      ],
      [
        1910.0,
        1417.968505859375,
        121.5624771118164
      ],
      [
        1910.0,
        1417.968505859375,
        121.5624771118164
      ],
      [
        1951.0,
        1417.968505859375,
        121.5624771118164
      ],
      [
        1951.0,
        1400.0140380859375,
        120.001220703125
      ],
      [
        1878.2073974609375,
        1402.94091796875,
        120.25572967529297
      ],
      [
        1882.2340087890625,
        1417.968505859375,
        121.5624771118164
      ],
      [
        1882.2340087890625,
        1417.968505859375,
        120.0
      ],
      [
        1797.7659912109375,
        1417.968505859375,
        121.5624771118164
      ],
      [
        1801.7926025390625,
        1402.94091796875,
        120.25572967529297
      ],
      [
        1797.7659912109375,
        1417.968505859375,
        120.0
      ],
      [
        1801.7926025390625,
        1402.94091796875,
        120.25572967529297
      ],
      [
        1804.7335205078125,
        1400.0,
        120.0
      ],
      [
        1878.2073974609375,
        1402.94091796875,
        120.25572967529297
      ],
      [
        1875.2664794921875,
        1400.0,
        120.0
      ],
      [
        1795.8818359375,
        1425.0,
        122.17391204833984
      ],
      [
        1884.1181640625,
        1425.0,
        122.17391204833984
      ],
      [
        1795.8818359375,
        1425.0,
        122.17391204833984
      ],
      [
        1884.1181640625,
        1425.0,
        122.17391204833984
      ],
      [
        1770.0,
        1400.0,
        138.0
      ],
      [
        1770.0,
        1450.0,
        138.0
      ],
      [
        1770.0,
        1450.0,
        138.0
      ],
      [
        1770.0,
        1469.9998779296875,
        138.0
      ],
      [
        2014.7547607421875,
        1453.431396484375,
        138.0
      ],
      [
        2014.7547607421875,
        1353.199951171875,
        138.0
      ],
      [
        2014.7547607421875,
        1453.431396484375,
        138.0
      ],
      [
        2014.7547607421875,
        1469.9998779296875,
        138.0
      ],
      [
        1951.0,
        1427.968505859375,
        138.0
      ],
      [
        1951.0,
        1417.968505859375,
        138.0
      ],
      [
        1951.0,
        1453.431396484375,
        138.0
      ],
      [
        1951.0,
        1427.968505859375,
        138.0
      ],
      [
        1951.0,
        1417.968505859375,
        138.0
      ],
      [
        1951.0,
        1353.199951171875,
        138.0
      ],
      [
        1680.0,
        1400.0,
        138.0
      ],
      [
        1770.0,
        1400.0,
        138.0
      ],
      [
        1655.0,
        1468.0,
        138.0
      ],
      [
        1630.0,
        1468.0,
        138.0
      ],
      [
        1770.0,
        1468.0,
        138.0
      ],
      [
        1695.0,
        1468.0,
        138.0
      ],
      [
        1655.0001220703125,
        1441.0001220703125,
        138.0
      ],
      [
        1653.0001220703125,
        1441.0001220703125,
        138.0
      ],
      [
        1697.0,
        1441.0,
        138.0
      ],
      [
        1695.0,
        1441.0,
        138.0
      ],
      [
        1695.0,
        1441.0,
        138.0
      ],
      [
        1655.0001220703125,
        1441.0001220703125,
        138.0
      ],
      [
        1695.0,
        1450.0,
        140.0
      ],
      [
        1697.0,
        1468.0,
        138.0
      ],
      [
        1697.0,
        1450.0,
        138.0
      ],
      [
        1697.0,
        1441.0,
        138.0
      ],
      [
        1680.0,
        1439.9998779296875,
        140.0
      ],
      [
        1680.0,
        1440.9998779296875,
        138.0
      ],
      [
        1951.0,
        1400.0,
        120.001220703125
      ],
      [
        1974.56298828125,
        1400.0,
        120.001220703125
      ],
      [
        2008.634765625,
        1400.0,
        120.001220703125
      ],
      [
        2008.63330078125,
        1400.0,
        120.0
      ],
      [
        2015.62939453125,
        1400.0,
        135.99945068359375
      ],
      [
        2008.634765625,
        1400.0,
        120.001220703125
      ],
      [
        1951.0,
        1400.0,
        120.001220703125
      ],
      [
        1951.0,
        1400.0,
        138.0
      ],
      [
        1883.30126953125,
        1400.0,
        135.0
      ],
      [
        1796.69873046875,
        1400.0,
        135.0
      ],
      [
        1804.7335205078125,
        1400.0,
        135.0
      ],
      [
        1796.69873046875,
        1400.0,
        135.0
      ],
      [
        1883.30126953125,
        1400.0,
        135.0
      ],
      [
        1875.2664794921875,
        1400.0,
        135.0
      ],
      [
        1804.7335205078125,
        1400.0,
        135.0
      ],
      [
        1875.2664794921875,
        1400.0,
        135.0
      ],
      [
        1902.6785888671875,
        1397.6761474609375,
        120.0
      ],
      [
        1902.6785888671875,
        1397.6761474609375,
        135.0
      ],
      [
        1777.3212890625,
        1397.6763916015625,
        120.0
      ],
      [
        1777.3212890625,
        1397.6763916015625,
        135.0
      ],
      [
        1863.0941162109375,
        1465.0,
        135.0
      ],
      [
        1895.621826171875,
        1465.0,
        135.0
      ],
      [
        1784.378173828125,
        1465.0,
        135.0
      ],
      [
        1816.9058837890625,
        1465.0,
        135.0
      ],
      [
        1855.3695068359375,
        1465.0,
        135.0
      ],
      [
        1863.0941162109375,
        1465.0,
        135.0
      ],
      [
        1816.9058837890625,
        1465.0,
        135.0
      ],
      [
        1824.6304931640625,
        1465.0,
        135.0
      ],
      [
        1770.0,
        1469.9998779296875,
        135.0
      ],
      [
        1770.0,
        1468.0001220703125,
        138.0
      ],
      [
        1770.0,
        1465.0001220703125,
        135.0
      ],
      [
        2015.62939453125,
        1465.99951171875,
        135.99945068359375
      ],
      [
        2015.1923828125,
        1465.0,
        135.0
      ],
      [
        2015.1923828125,
        1469.9998779296875,
        135.0
      ],
      [
        1824.6304931640625,
        1465.0,
        135.0
      ],
      [
        1817.9407958984375,
        1463.20751953125,
        133.20755004882812
      ],
      [
        1862.0592041015625,
        1463.20751953125,
        133.20755004882812
      ],
      [
        1855.3695068359375,
        1465.0,
        135.0
      ],
      [
        1817.9407958984375,
        1463.20751953125,
        133.20755004882812
      ],
      [
        1809.495361328125,
        1454.7618408203125,
        124.76189422607422
      ],
      [
        1862.0592041015625,
        1463.20751953125,
        133.20755004882812
      ],
      [
        1870.504638671875,
        1454.7618408203125,
        124.76189422607422
      ],
      [
        2010.7161865234375,
        1454.7618408203125,
        124.76190185546875
      ],
      [
        1900.6217041015625,
        1460.0,
        130.00003051757812
      ],
      [
        1895.621826171875,
        1465.0,
        135.0
      ],
      [
        1900.6217041015625,
        1460.0,
        130.00003051757812
      ],
      [
        1902.0252685546875,
        1454.7618408203125,
        124.76190185546875
      ],
      [
        1770.0,
        1454.7618408203125,
        124.76190185546875
      ],
      [
        1779.378173828125,
        1460.0,
        130.00003051757812
      ],
      [
        1784.378173828125,
        1465.0,
        135.0
      ],
      [
        1779.378173828125,
        1460.0,
        130.00003051757812
      ],
      [
        1777.974609375,
        1454.7618408203125,
        124.76190185546875
      ],
      [
        1770.0,
        1450.0,
        135.0
      ],
      [
        1770.0,
        1465.0001220703125,
        135.0
      ],
      [
        1951.0,
        1427.968505859375,
        135.0
      ],
      [
        1951.0,
        1417.968505859375,
        135.0
      ],
      [
        1951.0,
        1453.431396484375,
        135.0
      ],
      [
        1951.0,
        1427.968505859375,
        135.0
      ],
      [
        1951.0,
        1417.968505859375,
        135.0
      ],
      [
        1951.0,
        1400.0,
        135.0
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        1.0,
        9.39002404720668e-07,
        0.0
      ],
      "plane_d": -1630.0013427734375,
      "bbox_min": [
        1250.0,
        1170.0,
        100.0
      ],
      "bbox_max": [
        2015.62939453125,
        1690.0,
        490.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        1250.0,
        1220.0,
        100.0
      ],
      "bbox_max": [
        1630.0,
        1690.0,
        490.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -21.21319580078125,
      "bbox_min": [
        1250.0,
        1220.0,
        100.0
      ],
      "bbox_max": [
        1499.7784423828125,
        1400.0,
        290.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -70.71063232421875,
      "bbox_min": [
        1327.071044921875,
        1247.071044921875,
        138.0
      ],
      "bbox_max": [
        1499.7784423828125,
        1400.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1327.071044921875,
        1247.071044921875,
        138.0
      ],
      "bbox_max": [
        1499.7784423828125,
        1400.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9999687075614929,
        -0.007910480722784996,
        0.0
      ],
      "plane_d": -1488.6568603515625,
      "bbox_min": [
        1499.7767333984375,
        1399.7767333984375,
        138.0
      ],
      "bbox_max": [
        1499.7784423828125,
        1400.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1480.0,
      "bbox_min": [
        1430.0,
        1400.0,
        115.65217590332031
      ],
      "bbox_max": [
        1630.0,
        1690.0,
        490.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -21.21319580078125,
      "bbox_min": [
        1430.0,
        1400.0,
        115.65217590332031
      ],
      "bbox_max": [
        1480.0,
        1450.0,
        290.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1460.0,
        1400.0,
        138.0
      ],
      "bbox_max": [
        1480.0,
        1428.0,
        138.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1550.0,
      "bbox_min": [
        1480.0,
        1469.9998779296875,
        120.0
      ],
      "bbox_max": [
        1560.0001220703125,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 137.99998474121094,
      "bbox_min": [
        1480.0,
        1469.9998779296875,
        120.0
      ],
      "bbox_max": [
        1550.0,
        1610.0,
        138.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1480.0,
        1469.9998779296875,
        120.0
      ],
      "bbox_max": [
        1550.0,
        1500.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1550.0,
        1469.9998779296875,
        120.0
      ],
      "bbox_max": [
        1560.0001220703125,
        1480.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1480.0,
        1400.0,
        120.0
      ],
      "bbox_max": [
        1630.0,
        1470.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1480.0,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1630.0,
        1470.0,
        140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.2938015743202413e-06,
        -0.7071091532707214,
        0.7071043252944946
      ],
      "plane_d": 940.4536743164062,
      "bbox_min": [
        1500.0,
        1450.0,
        138.0
      ],
      "bbox_max": [
        1630.0,
        1470.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1500.0,
      "bbox_min": [
        1500.0,
        1467.999755859375,
        138.0
      ],
      "bbox_max": [
        1500.0,
        1470.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1500.0,
      "bbox_min": [
        1500.0,
        1450.0,
        138.0
      ],
      "bbox_max": [
        1500.0,
        1470.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.2938015743202413e-06,
        -0.7071091532707214,
        0.7071043252944946
      ],
      "plane_d": 940.4536743164062,
      "bbox_min": [
        1580.0,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1630.0,
        1468.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": -813.9287719726562,
      "bbox_min": [
        1480.0,
        1400.0,
        120.0
      ],
      "bbox_max": [
        1580.0,
        1450.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1439.9998779296875,
      "bbox_min": [
        1480.0,
        1400.0,
        120.0
      ],
      "bbox_max": [
        1580.0,
        1450.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1480.0,
        1440.0,
        138.0
      ],
      "bbox_max": [
        1540.0,
        1450.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1500.0,
      "bbox_min": [
        1500.0,
        1440.0,
        138.0
      ],
      "bbox_max": [
        1500.0,
        1450.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1480.0,
        1400.0,
        138.0
      ],
      "bbox_max": [
        1500.0,
        1440.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9999687075614929,
        -0.007910480722784996,
        0.0
      ],
      "plane_d": -1488.6568603515625,
      "bbox_min": [
        1499.7784423828125,
        1400.0,
        138.0
      ],
      "bbox_max": [
        1500.0,
        1440.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1500.0,
      "bbox_min": [
        1500.0,
        1428.0,
        138.0
      ],
      "bbox_max": [
        1500.0,
        1440.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1469.9998779296875,
      "bbox_min": [
        1630.0,
        1170.0,
        100.0
      ],
      "bbox_max": [
        2015.62939453125,
        1653.431396484375,
        370.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9162540435791016,
        1.222527714617172e-07,
        0.4005979001522064
      ],
      "plane_d": 1792.3472900390625,
      "bbox_min": [
        1655.0,
        1469.9998779296875,
        109.97534942626953
      ],
      "bbox_max": [
        2015.62939453125,
        1653.431396484375,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9162545204162598,
        -1.2225235934693046e-07,
        -0.400596559047699
      ],
      "plane_d": 1901.3106689453125,
      "bbox_min": [
        1655.0,
        1469.9998779296875,
        109.97534942626953
      ],
      "bbox_max": [
        2015.62939453125,
        1653.431396484375,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6440529823303223,
        2.3345367594629352e-07,
        0.7649810314178467
      ],
      "plane_d": 1201.8681640625,
      "bbox_min": [
        1655.0,
        1469.9998779296875,
        109.97534942626953
      ],
      "bbox_max": [
        2008.634765625,
        1653.431396484375,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1770.0,
      "bbox_min": [
        1655.0,
        1469.9998779296875,
        120.0
      ],
      "bbox_max": [
        1890.6220703125,
        1495.0001220703125,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881069898605347,
        -0.9659281373023987,
        0.0
      ],
      "plane_d": 1920.274169921875,
      "bbox_min": [
        1789.3779296875,
        1469.9998779296875,
        120.0
      ],
      "bbox_max": [
        1890.6220703125,
        1495.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881069898605347,
        -0.9659281373023987,
        0.0
      ],
      "plane_d": 967.8509521484375,
      "bbox_min": [
        1789.3779296875,
        1469.9998779296875,
        120.0
      ],
      "bbox_max": [
        1890.6220703125,
        1495.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 134.99998474121094,
      "bbox_min": [
        1789.3779296875,
        1469.9998779296875,
        120.0
      ],
      "bbox_max": [
        1890.6220703125,
        1495.0,
        135.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1789.3779296875,
        1469.9998779296875,
        120.0
      ],
      "bbox_max": [
        1890.6220703125,
        1495.0,
        135.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.7071118354797363,
        -0.7071017026901245,
        0.0
      ],
      "plane_d": -225.8509521484375,
      "bbox_min": [
        1789.3779296875,
        1469.9998779296875,
        120.0
      ],
      "bbox_max": [
        1890.6220703125,
        1485.6220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.70711350440979,
        -0.7071000337600708,
        0.0
      ],
      "plane_d": 2376.3212890625,
      "bbox_min": [
        1875.0001220703125,
        1469.9998779296875,
        120.0
      ],
      "bbox_max": [
        1890.6220703125,
        1485.6220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1655.0,
        1469.9998779296875,
        120.0
      ],
      "bbox_max": [
        1695.0,
        1495.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        8.138020348269492e-06
      ],
      "plane_d": -1655.0009765625,
      "bbox_min": [
        1655.0,
        1469.9998779296875,
        120.0
      ],
      "bbox_max": [
        1655.0001220703125,
        1495.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.08662962168455124,
        0.9962406754493713
      ],
      "plane_d": 1.7325897216796875,
      "bbox_min": [
        1630.0,
        1170.0,
        100.0
      ],
      "bbox_max": [
        2015.62939453125,
        1470.0,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1630.0,
        1353.199951171875,
        109.975341796875
      ],
      "bbox_max": [
        2011.2955322265625,
        1469.9998779296875,
        126.08694458007812
      ],
      "face_count": 16
    },
    {
      "plane_normal": [
        -0.6440575122833252,
        0.0,
        0.7649770379066467
      ],
      "plane_d": 1201.8780517578125,
      "bbox_min": [
        1996.7265625,
        1353.199951171875,
        109.975341796875
      ],
      "bbox_max": [
        2008.634765625,
        1469.9998779296875,
        120.001220703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": 940.4520874023438,
      "bbox_min": [
        1630.0,
        1400.0,
        120.0
      ],
      "bbox_max": [
        2011.2955322265625,
        1469.9998779296875,
        126.08694458007812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.25881627202033997,
        0.9659266471862793,
        0.0
      ],
      "plane_d": -942.83837890625,
      "bbox_min": [
        1655.0001220703125,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1903.30126953125,
        1469.9998779296875,
        126.08694458007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071094512939453,
        0.7071041464805603,
        -5.75447211303981e-06
      ],
      "plane_d": 250.84375,
      "bbox_min": [
        1770.0,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1903.30126953125,
        1463.20751953125,
        125.49629974365234
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071094512939453,
        0.7071041464805603,
        -0.0
      ],
      "plane_d": -2351.31982421875,
      "bbox_min": [
        1862.05908203125,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1903.30126953125,
        1463.20751953125,
        125.49629974365234
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659240245819092,
        -0.2588256597518921,
        -0.0
      ],
      "plane_d": 2213.74169921875,
      "bbox_min": [
        1902.6785888671875,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1903.30126953125,
        1452.32373046875,
        122.32376861572266
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659240245819092,
        -0.2588256597518921,
        -7.860709956730716e-06
      ],
      "plane_d": -1340.857666015625,
      "bbox_min": [
        1770.0,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1777.3212890625,
        1452.3236083984375,
        122.32359313964844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1770.0,
      "bbox_min": [
        1770.0,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1770.0,
        1450.36181640625,
        120.36188507080078
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1770.0,
      "bbox_min": [
        1770.0,
        1450.36181640625,
        120.0
      ],
      "bbox_max": [
        1789.3779296875,
        1469.9998779296875,
        126.08694458007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071118354797363,
        -0.7071017026901245,
        0.0
      ],
      "plane_d": -225.8509521484375,
      "bbox_min": [
        1777.3212890625,
        1452.3236083984375,
        120.0
      ],
      "bbox_max": [
        1789.3779296875,
        1469.9998779296875,
        126.08694458007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659240245819092,
        -0.2588256597518921,
        -7.860709956730716e-06
      ],
      "plane_d": -1340.857666015625,
      "bbox_min": [
        1777.3212890625,
        1452.3236083984375,
        120.0
      ],
      "bbox_max": [
        1779.378173828125,
        1460.0,
        125.21739196777344
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9162540435791016,
        1.222527714617172e-07,
        0.4005979001522064
      ],
      "plane_d": 1792.3472900390625,
      "bbox_min": [
        1890.6220703125,
        1450.001220703125,
        120.0
      ],
      "bbox_max": [
        2011.2955322265625,
        1469.9998779296875,
        126.08694458007812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.70711350440979,
        -0.7071000337600708,
        0.0
      ],
      "plane_d": 2376.3212890625,
      "bbox_min": [
        1890.6220703125,
        1450.001220703125,
        120.0
      ],
      "bbox_max": [
        1951.0,
        1469.9998779296875,
        126.08694458007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1951.0,
      "bbox_min": [
        1951.0,
        1450.001220703125,
        120.001220703125
      ],
      "bbox_max": [
        1951.0,
        1453.431396484375,
        123.43146514892578
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659240245819092,
        -0.2588256597518921,
        -0.0
      ],
      "plane_d": 2213.74169921875,
      "bbox_min": [
        1900.6217041015625,
        1452.32373046875,
        120.0
      ],
      "bbox_max": [
        1902.6785888671875,
        1460.0,
        125.21739196777344
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9162539839744568,
        0.0,
        0.40059787034988403
      ],
      "plane_d": 1792.3472900390625,
      "bbox_min": [
        1650.0,
        1400.0,
        120.0
      ],
      "bbox_max": [
        2010.7161865234375,
        1454.761962890625,
        124.76190948486328
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1951.0,
      "bbox_min": [
        1650.0,
        1427.968505859375,
        120.0
      ],
      "bbox_max": [
        1951.0,
        1454.761962890625,
        124.76190948486328
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1910.0,
      "bbox_min": [
        1650.0,
        1427.968505859375,
        120.0
      ],
      "bbox_max": [
        1910.0,
        1454.761962890625,
        124.76190948486328
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659253358840942,
        0.2588212490081787,
        -0.0
      ],
      "plane_d": -2188.73779296875,
      "bbox_min": [
        1801.7926025390625,
        1427.968505859375,
        120.0
      ],
      "bbox_max": [
        1910.0,
        1454.7618408203125,
        124.76190185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071094512939453,
        0.7071041464805603,
        -5.75447211303981e-06
      ],
      "plane_d": 250.84375,
      "bbox_min": [
        1801.7926025390625,
        1447.05908203125,
        120.0
      ],
      "bbox_max": [
        1878.2073974609375,
        1454.7618408203125,
        124.76189422607422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071094512939453,
        0.7071041464805603,
        -0.0
      ],
      "plane_d": -2351.31982421875,
      "bbox_min": [
        1870.504638671875,
        1447.05908203125,
        120.0
      ],
      "bbox_max": [
        1878.2073974609375,
        1454.7618408203125,
        124.76189422607422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        1902.0252685546875,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1910.0,
        1454.7618408203125,
        124.76190185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659240245819092,
        -0.2588256597518921,
        -0.0
      ],
      "plane_d": 2213.74169921875,
      "bbox_min": [
        1902.0252685546875,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1903.30126953125,
        1454.7618408203125,
        124.76190185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        8.138020348269492e-06
      ],
      "plane_d": -1700.0009765625,
      "bbox_min": [
        1650.0,
        1447.9166259765625,
        120.0
      ],
      "bbox_max": [
        1777.974609375,
        1454.761962890625,
        124.76190948486328
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        8.138020348269492e-06
      ],
      "plane_d": -1655.0009765625,
      "bbox_min": [
        1650.0,
        1447.9166259765625,
        120.0
      ],
      "bbox_max": [
        1700.0001220703125,
        1454.761962890625,
        124.76190948486328
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.1835996449226514e-05,
        -0.894424319267273,
        -0.44721946120262146
      ],
      "plane_d": 1350.545654296875,
      "bbox_min": [
        1650.0,
        1447.9166259765625,
        120.0
      ],
      "bbox_max": [
        1655.0001220703125,
        1450.0001220703125,
        124.16667175292969
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -7.286726940947119e-06,
        -0.8944242596626282,
        -0.4472194314002991
      ],
      "plane_d": 1350.593994140625,
      "bbox_min": [
        1695.0,
        1447.9166259765625,
        120.0
      ],
      "bbox_max": [
        1700.0001220703125,
        1450.0001220703125,
        124.16667175292969
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        1770.0,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1777.974609375,
        1454.7618408203125,
        124.76190185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659240245819092,
        -0.2588256597518921,
        -7.860709956730716e-06
      ],
      "plane_d": -1340.857666015625,
      "bbox_min": [
        1770.0,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1777.974609375,
        1454.7618408203125,
        124.76190185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1770.0,
      "bbox_min": [
        1770.0,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1770.0,
        1454.7618408203125,
        124.76190185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1417.968505859375,
      "bbox_min": [
        1795.8818359375,
        1400.0,
        120.0
      ],
      "bbox_max": [
        1951.0,
        1427.968505859375,
        122.43204498291016
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1910.0,
      "bbox_min": [
        1797.7659912109375,
        1400.0,
        120.0
      ],
      "bbox_max": [
        1951.0,
        1417.968505859375,
        121.5624771118164
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1951.0,
      "bbox_min": [
        1951.0,
        1400.0140380859375,
        120.001220703125
      ],
      "bbox_max": [
        1951.0,
        1417.968505859375,
        121.5624771118164
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659253358840942,
        -0.2588212490081787,
        0.0
      ],
      "plane_d": -1451.09716796875,
      "bbox_min": [
        1797.7659912109375,
        1400.0,
        120.0
      ],
      "bbox_max": [
        1882.2340087890625,
        1417.968505859375,
        121.5624771118164
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071121335029602,
        -0.7071014642715454,
        -5.754493940912653e-06
      ],
      "plane_d": -336.0809326171875,
      "bbox_min": [
        1875.2664794921875,
        1400.0,
        120.0
      ],
      "bbox_max": [
        1878.2073974609375,
        1402.94091796875,
        120.25572967529297
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659253358840942,
        -0.2588212490081787,
        0.0
      ],
      "plane_d": -1451.09716796875,
      "bbox_min": [
        1795.8818359375,
        1417.968505859375,
        120.0
      ],
      "bbox_max": [
        1884.1181640625,
        1427.968505859375,
        122.43204498291016
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659253358840942,
        0.2588212490081787,
        0.0
      ],
      "plane_d": 1365.867431640625,
      "bbox_min": [
        1795.8818359375,
        1425.0,
        120.0
      ],
      "bbox_max": [
        1884.1181640625,
        1427.968505859375,
        122.43204498291016
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659253358840942,
        0.2588212490081787,
        -0.0
      ],
      "plane_d": -2188.73779296875,
      "bbox_min": [
        1883.32275390625,
        1425.0,
        120.0
      ],
      "bbox_max": [
        1884.1181640625,
        1427.968505859375,
        122.43204498291016
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1630.0,
        1210.0,
        115.93043518066406
      ],
      "bbox_max": [
        2015.62939453125,
        1470.0,
        230.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1770.0,
      "bbox_min": [
        1630.0,
        1353.199951171875,
        138.0
      ],
      "bbox_max": [
        2014.7547607421875,
        1470.0,
        230.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9162545800209045,
        -0.0,
        -0.40059658885002136
      ],
      "plane_d": 1901.3106689453125,
      "bbox_min": [
        1951.0,
        1353.199951171875,
        138.0
      ],
      "bbox_max": [
        2014.7547607421875,
        1469.9998779296875,
        151.99774169921875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1951.0,
      "bbox_min": [
        1951.0,
        1353.199951171875,
        138.0
      ],
      "bbox_max": [
        1951.0,
        1453.431396484375,
        140.99774169921875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        1630.0,
        1400.0,
        138.0
      ],
      "bbox_max": [
        1770.0,
        1470.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1410.0,
      "bbox_min": [
        1630.0,
        1400.0,
        138.0
      ],
      "bbox_max": [
        1770.0,
        1470.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49613896012306213,
        0.0,
        -0.8682432174682617
      ],
      "plane_d": -713.6958618164062,
      "bbox_min": [
        1680.0,
        1400.0,
        138.0
      ],
      "bbox_max": [
        1750.0,
        1410.0,
        178.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": 940.4520874023438,
      "bbox_min": [
        1630.0,
        1410.0,
        138.0
      ],
      "bbox_max": [
        1770.0,
        1470.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.8944272398948669,
        -0.44721361994743347
      ],
      "plane_d": 1350.5850830078125,
      "bbox_min": [
        1630.0,
        1410.0,
        138.0
      ],
      "bbox_max": [
        1720.0,
        1470.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        1630.0,
        1439.9998779296875,
        138.0
      ],
      "bbox_max": [
        1720.0,
        1470.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": -1297.541015625,
      "bbox_min": [
        1695.0,
        1450.0,
        138.0
      ],
      "bbox_max": [
        1697.0,
        1470.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1680.0,
      "bbox_min": [
        1680.0,
        1439.9998779296875,
        138.0
      ],
      "bbox_max": [
        1680.0,
        1450.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1680.0,
      "bbox_min": [
        1680.0,
        1410.0,
        138.0
      ],
      "bbox_max": [
        1680.0,
        1440.9998779296875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9162545800209045,
        -0.0,
        -0.40059658885002136
      ],
      "plane_d": 1901.3106689453125,
      "bbox_min": [
        1630.0,
        1353.199951171875,
        115.93043518066406
      ],
      "bbox_max": [
        2015.62939453125,
        1469.9998779296875,
        138.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        1630.0,
        1353.199951171875,
        115.93043518066406
      ],
      "bbox_max": [
        2015.62939453125,
        1469.9998779296875,
        138.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9162539839744568,
        0.0,
        0.40059787034988403
      ],
      "plane_d": 1792.3472900390625,
      "bbox_min": [
        1776.69873046875,
        1353.199951171875,
        120.0
      ],
      "bbox_max": [
        2015.62939453125,
        1400.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1951.0,
      "bbox_min": [
        1776.69873046875,
        1353.199951171875,
        120.0
      ],
      "bbox_max": [
        1951.0,
        1400.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 135.0,
      "bbox_min": [
        1776.69873046875,
        1355.0,
        120.0
      ],
      "bbox_max": [
        1903.30126953125,
        1400.0,
        135.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.2588115334510803,
        0.9659278392791748,
        0.0
      ],
      "plane_d": -832.6190185546875,
      "bbox_min": [
        1776.69873046875,
        1355.0,
        120.0
      ],
      "bbox_max": [
        1903.30126953125,
        1400.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2588115334510803,
        0.9659278392791748,
        -0.0
      ],
      "plane_d": -1785.04541015625,
      "bbox_min": [
        1776.69873046875,
        1355.0,
        120.0
      ],
      "bbox_max": [
        1903.30126953125,
        1400.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881490111351013,
        -0.9659269452095032,
        -2.1062412542960374e-06
      ],
      "plane_d": 1810.05078125,
      "bbox_min": [
        1776.69873046875,
        1380.8818359375,
        120.0
      ],
      "bbox_max": [
        1903.30126953125,
        1400.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881490111351013,
        -0.9659269452095032,
        0.0
      ],
      "plane_d": 857.6115112304688,
      "bbox_min": [
        1776.69873046875,
        1380.8818359375,
        120.0
      ],
      "bbox_max": [
        1903.30126953125,
        1400.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071121335029602,
        -0.7071014642715454,
        -0.0
      ],
      "plane_d": 2266.091064453125,
      "bbox_min": [
        1776.69873046875,
        1386.79248046875,
        120.0
      ],
      "bbox_max": [
        1903.30126953125,
        1400.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071121335029602,
        -0.7071014642715454,
        -5.754493940912653e-06
      ],
      "plane_d": -336.0809326171875,
      "bbox_min": [
        1862.05908203125,
        1386.79248046875,
        120.0
      ],
      "bbox_max": [
        1903.30126953125,
        1400.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659240245819092,
        0.2588256597518921,
        0.0
      ],
      "plane_d": 1476.0885009765625,
      "bbox_min": [
        1902.6785888671875,
        1397.6761474609375,
        120.0
      ],
      "bbox_max": [
        1903.30126953125,
        1400.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.965927004814148,
        0.25881466269493103,
        -0.0
      ],
      "plane_d": -2078.501708984375,
      "bbox_min": [
        1776.69873046875,
        1397.6763916015625,
        120.0
      ],
      "bbox_max": [
        1777.3212890625,
        1400.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659240245819092,
        0.2588256597518921,
        0.0
      ],
      "plane_d": 1476.0885009765625,
      "bbox_min": [
        1900.6217041015625,
        1390.0,
        120.0
      ],
      "bbox_max": [
        1902.6785888671875,
        1397.6761474609375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.965927004814148,
        0.25881466269493103,
        -0.0
      ],
      "plane_d": -2078.501708984375,
      "bbox_min": [
        1777.3212890625,
        1390.0,
        120.0
      ],
      "bbox_max": [
        1779.3782958984375,
        1397.6763916015625,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": 940.4520874023438,
      "bbox_min": [
        1630.0,
        1400.0,
        120.0
      ],
      "bbox_max": [
        2015.62939453125,
        1469.9998779296875,
        138.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 135.0,
      "bbox_min": [
        1655.0,
        1454.7618408203125,
        124.76189422607422
      ],
      "bbox_max": [
        2015.62939453125,
        1469.9998779296875,
        138.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1770.0,
      "bbox_min": [
        1770.0,
        1465.0,
        135.0
      ],
      "bbox_max": [
        2015.62939453125,
        1469.9998779296875,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9162540435791016,
        1.222527714617172e-07,
        0.4005979001522064
      ],
      "plane_d": 1792.3472900390625,
      "bbox_min": [
        2015.1923828125,
        1465.0,
        135.0
      ],
      "bbox_max": [
        2015.62939453125,
        1469.9998779296875,
        135.99945068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881627202033997,
        0.9659266471862793,
        0.0
      ],
      "plane_d": -942.83837890625,
      "bbox_min": [
        1655.0,
        1454.7618408203125,
        124.76189422607422
      ],
      "bbox_max": [
        2015.1923828125,
        1469.9998779296875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881627202033997,
        0.9659266471862793,
        -2.106252395606134e-06
      ],
      "plane_d": -1895.2821044921875,
      "bbox_min": [
        1809.495361328125,
        1454.7618408203125,
        124.76189422607422
      ],
      "bbox_max": [
        2015.1923828125,
        1469.9998779296875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071094512939453,
        0.7071041464805603,
        -5.75447211303981e-06
      ],
      "plane_d": 250.84375,
      "bbox_min": [
        1809.495361328125,
        1454.7618408203125,
        124.76189422607422
      ],
      "bbox_max": [
        1870.504638671875,
        1463.20751953125,
        133.20755004882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071094512939453,
        0.7071041464805603,
        -0.0
      ],
      "plane_d": -2351.31982421875,
      "bbox_min": [
        1862.05908203125,
        1454.7618408203125,
        124.76189422607422
      ],
      "bbox_max": [
        1870.504638671875,
        1463.20751953125,
        133.20755004882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9162540435791016,
        1.222527714617172e-07,
        0.4005979001522064
      ],
      "plane_d": 1792.3472900390625,
      "bbox_min": [
        1890.6220703125,
        1454.7618408203125,
        124.76190185546875
      ],
      "bbox_max": [
        2015.1923828125,
        1469.9998779296875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.70711350440979,
        -0.7071000337600708,
        0.0
      ],
      "plane_d": 2376.3212890625,
      "bbox_min": [
        1890.6220703125,
        1454.7618408203125,
        124.76190185546875
      ],
      "bbox_max": [
        1902.0252685546875,
        1469.9998779296875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659240245819092,
        -0.2588256597518921,
        -0.0
      ],
      "plane_d": 2213.74169921875,
      "bbox_min": [
        1900.6217041015625,
        1454.7618408203125,
        124.76190185546875
      ],
      "bbox_max": [
        1902.0252685546875,
        1460.0,
        130.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1770.0,
      "bbox_min": [
        1655.0,
        1454.7618408203125,
        124.76190185546875
      ],
      "bbox_max": [
        1789.3779296875,
        1469.9998779296875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071118354797363,
        -0.7071017026901245,
        0.0
      ],
      "plane_d": -225.8509521484375,
      "bbox_min": [
        1777.974609375,
        1454.7618408203125,
        124.76190185546875
      ],
      "bbox_max": [
        1789.3779296875,
        1469.9998779296875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659240245819092,
        -0.2588256597518921,
        -7.860709956730716e-06
      ],
      "plane_d": -1340.857666015625,
      "bbox_min": [
        1777.974609375,
        1454.7618408203125,
        124.76190185546875
      ],
      "bbox_max": [
        1779.378173828125,
        1460.0,
        130.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        8.138020348269492e-06
      ],
      "plane_d": -1655.0009765625,
      "bbox_min": [
        1655.0,
        1454.761962890625,
        124.76190948486328
      ],
      "bbox_max": [
        1655.0001220703125,
        1469.9998779296875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9162539839744568,
        0.0,
        0.40059787034988403
      ],
      "plane_d": 1792.3472900390625,
      "bbox_min": [
        1650.0,
        1400.0,
        120.0
      ],
      "bbox_max": [
        2015.62939453125,
        1468.0001220703125,
        138.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 135.0,
      "bbox_min": [
        1650.0,
        1400.0,
        120.0
      ],
      "bbox_max": [
        1974.56298828125,
        1468.0001220703125,
        138.0
      ],
      "face_count": 13
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1951.0,
      "bbox_min": [
        1951.0,
        1400.0,
        135.0
      ],
      "bbox_max": [
        1951.0,
        1453.431396484375,
        138.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.8944272398948669,
        -0.44721361994743347
      ],
      "plane_d": 1350.5850830078125,
      "bbox_min": [
        1650.0,
        1441.0,
        135.0
      ],
      "bbox_max": [
        1700.0,
        1468.0,
        138.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": -1297.541015625,
      "bbox_min": [
        1697.0,
        1441.0,
        135.0
      ],
      "bbox_max": [
        1700.0,
        1468.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1910.0,
      "bbox_min": [
        1650.0,
        1400.0,
        120.0
      ],
      "bbox_max": [
        1974.56298828125,
        1465.0001220703125,
        135.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.001220703125,
      "bbox_min": [
        1951.0,
        1400.0,
        120.001220703125
      ],
      "bbox_max": [
        1974.56298828125,
        1417.968505859375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1951.0,
      "bbox_min": [
        1951.0,
        1400.0,
        120.001220703125
      ],
      "bbox_max": [
        1951.0,
        1417.968505859375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1427.968505859375,
      "bbox_min": [
        1910.0,
        1417.968505859375,
        122.43204498291016
      ],
      "bbox_max": [
        1951.0,
        1453.431396484375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1951.0,
      "bbox_min": [
        1951.0,
        1427.968505859375,
        122.43204498291016
      ],
      "bbox_max": [
        1951.0,
        1453.431396484375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 132.00128173828125,
      "bbox_min": [
        1910.0,
        1417.968505859375,
        132.00128173828125
      ],
      "bbox_max": [
        1951.0,
        1427.968505859375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1951.0,
      "bbox_min": [
        1951.0,
        1417.968505859375,
        132.00128173828125
      ],
      "bbox_max": [
        1951.0,
        1427.968505859375,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659253358840942,
        -0.2588212490081787,
        -0.0
      ],
      "plane_d": 2103.508056640625,
      "bbox_min": [
        1650.0,
        1400.0,
        120.0
      ],
      "bbox_max": [
        1910.0,
        1465.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659253358840942,
        -0.2588212490081787,
        0.0
      ],
      "plane_d": -1451.09716796875,
      "bbox_min": [
        1795.8818359375,
        1400.0,
        120.0
      ],
      "bbox_max": [
        1910.0,
        1465.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659253358840942,
        0.2588212490081787,
        0.0
      ],
      "plane_d": 1365.867431640625,
      "bbox_min": [
        1795.8818359375,
        1400.0,
        120.0
      ],
      "bbox_max": [
        1884.1181640625,
        1465.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659253358840942,
        0.2588212490081787,
        -0.0
      ],
      "plane_d": -2188.73779296875,
      "bbox_min": [
        1801.7926025390625,
        1400.0,
        120.0
      ],
      "bbox_max": [
        1884.1181640625,
        1465.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071121335029602,
        -0.7071014642715454,
        -5.754493940912653e-06
      ],
      "plane_d": -336.0809326171875,
      "bbox_min": [
        1801.7926025390625,
        1400.0,
        120.0
      ],
      "bbox_max": [
        1878.2073974609375,
        1465.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881627202033997,
        0.9659266471862793,
        -2.106252395606134e-06
      ],
      "plane_d": -1895.2821044921875,
      "bbox_min": [
        1855.3695068359375,
        1463.20751953125,
        133.20755004882812
      ],
      "bbox_max": [
        1862.0592041015625,
        1465.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659240245819092,
        -0.2588256597518921,
        -0.0
      ],
      "plane_d": 2213.74169921875,
      "bbox_min": [
        1895.621826171875,
        1450.0,
        124.34782409667969
      ],
      "bbox_max": [
        1910.0,
        1465.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        1903.30126953125,
        1450.0,
        124.34782409667969
      ],
      "bbox_max": [
        1910.0,
        1450.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.70711350440979,
        -0.7071000337600708,
        0.0
      ],
      "plane_d": 2376.3212890625,
      "bbox_min": [
        1895.621826171875,
        1460.0,
        130.00003051757812
      ],
      "bbox_max": [
        1900.6217041015625,
        1465.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        8.138020348269492e-06
      ],
      "plane_d": -1700.0009765625,
      "bbox_min": [
        1650.0,
        1442.5,
        124.16666412353516
      ],
      "bbox_max": [
        1784.378173828125,
        1465.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        8.138020348269492e-06
      ],
      "plane_d": -1655.0009765625,
      "bbox_min": [
        1650.0,
        1442.5,
        124.16666412353516
      ],
      "bbox_max": [
        1700.0001220703125,
        1465.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.1835996449226514e-05,
        -0.894424319267273,
        -0.44721946120262146
      ],
      "plane_d": 1350.545654296875,
      "bbox_min": [
        1650.0,
        1442.5,
        124.16666412353516
      ],
      "bbox_max": [
        1655.0001220703125,
        1447.916748046875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -7.286726940947119e-06,
        -0.8944242596626282,
        -0.4472194314002991
      ],
      "plane_d": 1350.593994140625,
      "bbox_min": [
        1695.0,
        1442.5,
        124.16666412353516
      ],
      "bbox_max": [
        1700.0001220703125,
        1447.916748046875,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1770.0,
      "bbox_min": [
        1770.0,
        1450.0,
        124.34782409667969
      ],
      "bbox_max": [
        1784.378173828125,
        1465.0001220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659240245819092,
        -0.2588256597518921,
        -7.860709956730716e-06
      ],
      "plane_d": -1340.857666015625,
      "bbox_min": [
        1770.0,
        1450.0,
        124.34782409667969
      ],
      "bbox_max": [
        1784.378173828125,
        1465.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        1770.0,
        1450.0,
        124.34782409667969
      ],
      "bbox_max": [
        1776.69873046875,
        1450.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071118354797363,
        -0.7071017026901245,
        0.0
      ],
      "plane_d": -225.8509521484375,
      "bbox_min": [
        1779.378173828125,
        1460.0,
        130.00003051757812
      ],
      "bbox_max": [
        1784.378173828125,
        1465.0,
        135.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [],
  "tutorial_messages": []
}